import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./components/Menu.css";

import { Container, Card } from "react-bootstrap";
import Confetti from "react-confetti";
import { Link } from "react-router-dom";
import { useWindowSize } from "@uidotdev/usehooks";

export function App() {
  const { width, height } = useWindowSize();
  return (
    <Container className="py-5 text-center">
      <div className="confetti">
        <Confetti width={width} height={height} />
      </div>
      <Card className="bg-light p-5 shadow-sm rounded">
        <h1 className="display-3 mb-4">🎉 Ich wurde 30! 🎉</h1>

        <p className="lead">Und du bist eingeladen 🥳</p>

        <p>
          Am <strong>29. Juni</strong> feiern wir bei{" "}
          <strong>Mareike und mir</strong> zu Hause.
        </p>

        <p className="text-muted fst-italic">
          Es gibt Essen, Snacks, Drinks, Musik und{" "}
          <s>vielleicht sogar eine Hüpfburg.</s>
        </p>
        <p className="text-secondary small">
          Dresscode: Come as you are. Oder als Flamingo.
        </p>
        <Link to="/program">Zum Programm</Link>
      </Card>
    </Container>
  );
}

export default App;
